import React from 'react';
import { Link } from 'react-router-dom';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../../CourseDetail/components/messages';

const ProgramCoursesList = ({ courses }) => {
  const intl = useIntl();
  if (!courses || courses.length === 0) return null;

  const sorted = [...courses].sort((a, b) => {
    const nameA = a.course?.details?.displayName || '';
    const nameB = b.course?.details?.displayName || '';
    return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
  });

  return (
    <section className="program-detail__courses">
      <h2 className="program-detail__courses-title">
        {intl.formatMessage(messages.programCoursesTitle)}
      </h2>
      <ul className="program-detail__courses-list">
        {sorted.map((entry) => {
          const course = entry.course;
          const details = course?.details || {};
          const imageUrl = details.courseImageUrl
            ? `${getConfig().LMS_BASE_URL}${details.courseImageUrl}`
            : null;
          return (
            <li key={course.id} className="program-detail__courses-item">
              <Link
                to={`/discover/${encodeURIComponent(course.openedxCourseId)}`}
                className="program-detail__courses-link"
              >
                {imageUrl && (
                  <div
                    className="program-detail__courses-image"
                    role="img"
                    aria-label={details.displayName}
                    style={{ backgroundImage: `url(${imageUrl})` }}
                  />
                )}
                <div className="program-detail__courses-meta">
                  <span className="program-detail__courses-name">
                    {details.displayName || intl.formatMessage(messages.untitledCourse)}
                  </span>
                  {details.shortDescription && (
                    <span className="program-detail__courses-desc">
                      {details.shortDescription}
                    </span>
                  )}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ProgramCoursesList;
